import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface LogEntryDto {
    id: number;
    timestamp: string;
    logLevel: string;
    categoryName: string;
    message: string;
    userID?: number;
    username?: string;
}

export interface PagedResult<T> {
    data: T[];
    totalCount: number;
    page: number;
    pageSize: number;
    totalPages: number;
}

@Injectable({
    providedIn: 'root'
})
export class LogViewerService {
    private readonly baseURL = environment.baseApiUrl;

    constructor(private httpClient: HttpClient) { }

    getLogs(page: number, pageSize: number) {
        return this.httpClient.get<PagedResult<LogEntryDto>>(
            `${this.baseURL}Logs/GetLogs?page=${page}&pageSize=${pageSize}`
        );
    }
}